import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '../../api/client';

/** A `GET /me` válasza (`apps/api/src/auth/auth.controller.ts`). */
export interface Me {
  oid: string;
  displayName: string;
  username: string;
  tenantId: string;
}

/**
 * A bejelentkezett felhasználó. Ez az első hívás bejelentkezés után, és
 * egyben a teljes lánc próbája: MSAL token → Entra validáció → adatbázis
 * (a végpont `appUser` upsertet is végez, hogy az eseménynaplóban legyen
 * megjelenítendő név).
 */
export function useMe() {
  return useQuery({
    queryKey: ['me'],
    queryFn: ({ signal }) => apiFetch<Me>('/me', { signal }),
    staleTime: 5 * 60 * 1000,
  });
}
